import { render, staticRenderFns } from "./Cnpj.vue?vue&type=template&id=83e9b21c"
import script from "./Cnpj.vue?vue&type=script&lang=ts"
export * from "./Cnpj.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports